import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetailPage, serviceDetailHead } from "@/components/site/ServiceDetailPage";
import { serviceDetails } from "@/lib/service-details";

const service = serviceDetails.find((s) => s.slug === "reconciliations")!;

export const Route = createFileRoute("/services/reconciliations")({
  head: () => serviceDetailHead(service),
  component: () => <ServiceDetailPage service={service} />,
});
